import { render, staticRenderFns } from "./NewSample.vue?vue&type=template&id=550a364f&"
import script from "./NewSample.vue?vue&type=script&lang=js&"
export * from "./NewSample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports